(function(){
  'use strict';
  var money = function(cents){
    try { return (cents/100).toLocaleString(undefined,{style:'currency',currency:window.Shopify&&window.Shopify.currency?window.Shopify.currency.active:'AUD'}); }
    catch(e){ return '$'+(cents/100).toFixed(2); }
  };

  // ---- mobile nav
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-nav-toggle]');
    if(!t) return;
    var nav=document.getElementById(t.getAttribute('aria-controls'));
    if(!nav) return;
    var open=nav.classList.toggle('is-open');
    t.setAttribute('aria-expanded',open?'true':'false');
  });

  // ---- cart drawer
  var drawer=document.querySelector('[data-cart-drawer]');
  function openDrawer(){ if(drawer){ drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; } }
  function closeDrawer(){ if(drawer){ drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; } }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-cart-open]') && drawer){ e.preventDefault(); openDrawer(); }
    if(e.target.closest('[data-cart-close]')||e.target.closest('.drawer__scrim')) closeDrawer();
  });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDrawer(); });

  function refreshCart(){
    return fetch(window.Shopify&&window.Shopify.routes?window.Shopify.routes.root+'?section_id=cart-drawer':'/?section_id=cart-drawer')
      .then(function(r){return r.text();})
      .then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var fresh=doc.querySelector('[data-cart-drawer-contents]');
        var target=document.querySelector('[data-cart-drawer-contents]');
        if(fresh&&target) target.innerHTML=fresh.innerHTML;
        return fetch('/cart.js').then(function(r){return r.json();});
      })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent=cart.item_count; });
        return cart;
      });
  }

  // ---- add to cart (AJAX, real Shopify cart)
  document.addEventListener('submit',function(e){
    var form=e.target.closest('form[data-product-form]');
    if(!form) return;
    e.preventDefault();
    var btn=form.querySelector('[data-add-button]');
    var errEl=form.querySelector('[data-form-error]');
    if(errEl) errEl.textContent='';
    if(btn){ btn.setAttribute('aria-disabled','true'); btn.dataset.label=btn.textContent; btn.textContent='Adding…'; }
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded','Accept':'application/json'},body:new URLSearchParams(new FormData(form)).toString()})
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw d; return d; }); })
      .then(function(){ return refreshCart(); })
      .then(function(){ openDrawer(); })
      .catch(function(err){ if(errEl) errEl.textContent=(err&&err.description)||'Could not add to cart.'; })
      .finally(function(){ if(btn){ btn.removeAttribute('aria-disabled'); btn.textContent=btn.dataset.label||'Add to cart'; } });
  });

  // ---- cart line changes (drawer + cart page)
  document.addEventListener('click',function(e){
    var el=e.target.closest('[data-line-change]');
    if(!el) return;
    e.preventDefault();
    var line=el.getAttribute('data-line');
    var qty=el.getAttribute('data-qty');
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(line),quantity:Number(qty)})})
      .then(function(r){return r.json();})
      .then(function(){ if(document.body.classList.contains('template-cart')) window.location.reload(); else refreshCart(); });
  });
  document.addEventListener('change',function(e){
    var input=e.target.closest('[data-line-qty]');
    if(!input) return;
    fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:Number(input.getAttribute('data-line')),quantity:Number(input.value)})})
      .then(function(r){return r.json();})
      .then(function(){ if(document.body.classList.contains('template-cart')) window.location.reload(); else refreshCart(); });
  });

  // ---- quantity steppers
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-qty-step]');
    if(!b) return;
    var input=b.parentElement.querySelector('input');
    if(!input) return;
    var next=Number(input.value||1)+Number(b.getAttribute('data-qty-step'));
    input.value=Math.max(Number(input.min||1),next);
    input.dispatchEvent(new Event('change',{bubbles:true}));
  });

  // ---- variant selection (real Shopify variants)
  document.querySelectorAll('[data-variant-picker]').forEach(function(root){
    var data=root.querySelector('[data-variant-json]');
    if(!data) return;
    var variants=JSON.parse(data.textContent);
    var form=document.querySelector('form[data-product-form][data-section="'+root.getAttribute('data-section')+'"]');
    var idInput=form?form.querySelector('[data-variant-id]'):null;
    var priceEl=root.querySelector('[data-variant-price]');
    var btn=form?form.querySelector('[data-add-button]'):null;
    var skuEl=root.querySelector('[data-variant-sku]');
    var stockEl=root.querySelector('[data-variant-stock]');

    function selected(){
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'),function(group){
        var checked=group.querySelector('input:checked');
        return checked?checked.value:null;
      });
    }
    function match(){
      var sel=selected();
      return variants.find(function(v){ return v.options.every(function(o,i){ return o===sel[i]; }); });
    }
    function render(){
      var v=match();
      if(!v){ if(btn){ btn.setAttribute('aria-disabled','true'); btn.textContent='Unavailable'; } return; }
      if(idInput) idInput.value=v.id;
      if(priceEl){
        var html='<ins>'+money(v.price)+'</ins>';
        if(v.compare_at_price&&v.compare_at_price>v.price) html+=' <s>'+money(v.compare_at_price)+'</s>';
        priceEl.innerHTML=html;
      }
      if(skuEl) skuEl.textContent=v.sku||'';
      if(stockEl) stockEl.textContent=(v.available&&v.inventory_management&&v.inventory_quantity>0&&v.inventory_quantity<=3)?('Only '+v.inventory_quantity+' left'):'';
      if(btn){
        if(v.available){ btn.removeAttribute('aria-disabled'); btn.textContent='Add to cart'; }
        else { btn.setAttribute('aria-disabled','true'); btn.textContent='Sold out'; }
      }
      if(window.history&&window.history.replaceState){
        var url=new URL(window.location.href); url.searchParams.set('variant',v.id);
        window.history.replaceState({},'',url.toString());
      }
      document.querySelectorAll('[data-variant-media="'+v.id+'"]').forEach(function(t){ t.click(); });
    }
    root.addEventListener('change',render);
    render();
  });

  // ---- gallery
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-gallery-thumb]');
    if(!t) return;
    var root=t.closest('[data-gallery]');
    var main=root.querySelector('[data-gallery-main]');
    var img=t.querySelector('img');
    if(main&&img){ main.src=img.getAttribute('data-full')||img.src; main.srcset=''; }
    root.querySelectorAll('[data-gallery-thumb]').forEach(function(b){ b.setAttribute('aria-current',b===t?'true':'false'); });
  });

  // ---- sticky buy bar (phones)
  var buybar=document.querySelector('[data-buybar]');
  if(buybar){
    buybar.querySelector('[data-buybar-add]').addEventListener('click',function(){
      var form=document.querySelector('form[data-product-form]');
      if(form) form.requestSubmit?form.requestSubmit():form.dispatchEvent(new Event('submit',{cancelable:true,bubbles:true}));
    });
    var live=document.querySelector('[data-variant-price]');
    var mirror=buybar.querySelector('[data-variant-price-mirror]');
    if(live&&mirror&&window.MutationObserver){
      new MutationObserver(function(){ mirror.innerHTML=live.innerHTML; }).observe(live,{childList:true,subtree:true,characterData:true});
    }
  }

  // ---- swipe to close the cart drawer
  if(drawer){
    var panel=drawer.querySelector('.drawer__panel'),startX=null;
    panel.addEventListener('touchstart',function(e){ startX=e.touches[0].clientX; },{passive:true});
    panel.addEventListener('touchend',function(e){
      if(startX===null) return;
      if(e.changedTouches[0].clientX-startX>70) closeDrawer();
      startX=null;
    },{passive:true});
  }

  // ---- collection sort auto-submit
  document.querySelectorAll('[data-sort-select]').forEach(function(sel){
    sel.addEventListener('change',function(){ sel.form.submit(); });
  });
})();
